<template>
    <div>
        <v-row justify="center" class="mt-1 mb-2">
            <v-col cols="12" sm="12" md="7">
                <v-stepper id="questions-stepper" v-model="stepModal">
                    <v-stepper-header class="v-stepper__header-custom">
                        <template v-for="(item, n) in testObj.questions">
                            <v-stepper-step :key="`${n}-step`" :complete="stepModal > n" :step="n+1" editable />
                            <v-divider v-if="n !== (testObj.questions.length - 1)" :key="n" ></v-divider>
                        </template>
                    </v-stepper-header>

                    <v-stepper-items ref="stepperItems" class="stepper-custom t-overflow" style="overflow-y:auto;overflow-x:hidden;">
                        <v-stepper-content v-for="(item, n) in testObj.questions" :key="`${n}-content`" :step="n+1">
                            <v-card flat>
                                <questionType0
                                    v-if="item.questionType === 0 && (n+1 === stepModal)"
                                    v-on:addPercentageOfPassing="successPercentageOfPassing"
                                    v-on:getEstimation="getEstimationF"
                                    v-on:nextStep="nextQuestion()"
                                    v-on:save="saveQuest"
                                    :stepModal="stepModal"
                                    :item="item"
                                    :apiUrl="apiUrl"
                                />
                                <questionType1
                                    v-if="item.questionType === 1 && (n+1 === stepModal)"
                                    v-on:addPercentageOfPassing="successPercentageOfPassing"
                                    v-on:getEstimation="getEstimationF"
                                    v-on:nextStep="nextQuestion()"
                                    v-on:save="saveQuest"
                                    :stepModal="stepModal"
                                    :item="item"
                                    :apiUrl="apiUrl"
                                />
                                <questionType2
                                    v-if="item.questionType === 2 && (n+1 === stepModal)"
                                    v-on:addPercentageOfPassing="successPercentageOfPassing"
                                    v-on:getEstimation="getEstimationF"
                                    v-on:nextStep="nextQuestion()"
                                    v-on:save="saveQuest"
                                    :stepModal="stepModal"
                                    :item="item"
                                    :apiUrl="apiUrl"
                                />
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600px" persistent>
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
						Ваш процент прохождения
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn :disabled="loadBtn" icon color="rgba(129, 182, 228, 0.95)" @click="close(false)">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text class="pb-0">
					<v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" align="center">
                                <span
                                    class="text-h2 font-weight-bold"
                                    :class="{
                                        'red--text': calculatePercent(0, 39),
                                        'yellow--text text--darken-1': calculatePercent(40, 69),
                                        'green--text': calculatePercent(70, 100)
                                    }"
                                >
                                    {{ percentageOfPassing }}%
                                </span>
                            </v-col>
                            <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" align="center">
                                <v-icon class="x3-large" color="red" v-if="calculatePercent(0, 39)">mdi-thumb-down</v-icon>
                                <v-icon class="x3-large" color="yellow darken-1" v-if="calculatePercent(40, 69)">mdi-emoticon-neutral-outline</v-icon>
                                <v-icon class="x3-large" color="green" v-if="calculatePercent(70, 100)">mdi-thumb-up</v-icon>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" align="center">
                                <span v-if="calculatePercent(0, 39)" class="text-h5">
                                    {{ text }}
                                </span>
                                <span v-if="calculatePercent(40, 69)" class="text-h5">
                                    {{ text }}
                                </span>
                                <span v-if="calculatePercent(70, 90)" class="text-h5">
                                    {{ text }}
                                </span>
                                <span v-if="calculatePercent(91, 100)" class="text-h5">
                                    {{ text }}
                                </span>
                            </v-col>
                        </v-row>
					</v-container>
				</v-card-text>

				<v-card-actions>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12" align="center">
                                <v-btn :loading="loadBtn" @click="saveResult(objSave)" color="success" dark>Сохранить результат</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
				</v-card-actions>
			</v-card>
		</v-dialog>
    </div>
</template>

<script>
import questionType0 from './questionType0.vue'
import questionType1 from './questionType1.vue'
import questionType2 from './questionType2.vue'
import { mapActions } from 'vuex'

export default {
    props: {
        apiUrl: { type: String, default: () => '' },
        testObj: { type: Object, default: () => {} },
        clientH: { type: Number, default: () => 0 }
    },
    components: {
        questionType0,
        questionType1,
        questionType2
    },
    data:() => ({
        dialog: false,
        stepModal: 1,
        percentageOfPassing: 0,
        loadBtn: false,
        objSave: {
            questions: []
        },
        text: ''
    }),
    methods: {
        ...mapActions({
            randomGenerate: 'tests/randomGenerate'
        }),
        nextQuestion() {
            this.stepModal += 1;
            this.$emit('nextQuestion');
        },
        calculatePercent(start, end) {
            if(this.percentageOfPassing >= start && this.percentageOfPassing <= end) {
                return true
            }

            return false
        },
        successPercentageOfPassing() {
            this.percentageOfPassing += 10;
        },
        saveQuest(obj, type) {

            if(type === 0) {
                this.objSave.questions.push({
                    id: obj.item.id,
                    selectedAnswers: [
                        {
                            id: obj.item.answers[obj.ind].id
                        }
                    ],
                    selectedTermAnswers: obj.item.termAnswers
                })

                return;
            }
            
            if(type === 1) {
                this.objSave.questions.push({
                    id: obj.item.id,
                    selectedAnswers: obj.array.map((m) => ({ id: m })),
                    selectedTermAnswers: obj.item.termAnswers
                })

                return;
            }
            
            if(type === 2) {
                this.objSave.questions.push({
                    id: obj.item.id,
                    selectedAnswers: [],
                    selectedTermAnswers: obj.item.terms.map((m) => ({ id: m.selected.id, testQuestionTermId: m.id }))
                })

                return;
            }
            
        },
        saveResult(objSave) {
            this.loadBtn = true;
            this.$http.post(`${this.apiUrl}TestTask/AddResult`, {
                testId: this.testObj.id,
                questions: objSave.questions
            })
            .then(() => {
                this.close(true);
            })
        },
        close(flag) {
            this.stepModal = 1;
            this.percentageOfPassing = 0;
            this.$emit('closeTest', flag);
        },
        scrollToBottom() {
            console.log('scrollToBottom');
            // console.log(this.$refs.stepperItems.sc);
            // console.log(this.$refs.stepperItems2);
            // this.$refs.stepperItems.scrollTo({ top: '10000px', behavior: 'smooth' });
        },
        getEstimationF() {
            if(this.calculatePercent(0, 39)) this.getText('0_39');
            if(this.calculatePercent(40, 69)) this.getText('40_69');
            if(this.calculatePercent(70, 90)) this.getText('70_90');
            if(this.calculatePercent(91, 100)) this.getText('91_100');

            this.dialog = true;
        },
        getText(name) {
            this.randomGenerate(name).then((res) => {
                this.text = res;
            })
        }
    }
}
</script>

<style>
@media screen and (max-width: 1399px) {
    .stepper-custom {
        max-height: 530px;
    }
}
@media screen and (min-width: 1400px) and (max-width: 1728px) {
    .stepper-custom {
        max-height: 770px;
    }
}
@media screen and (min-width: 1729px) {
    .stepper-custom {
        max-height: 1120px;
    }
}

.t-overflow::-webkit-scrollbar {
	width: 10px; /* высота полосы прокрутки */
}

.t-overflow::-webkit-scrollbar-track {
	background: rgba(168, 177, 206, 0.3); /* цвет зоны отслеживания */
}

.t-overflow::-webkit-scrollbar-thumb {
	background: #3377ff;
	border-radius: 10px;
}
.x3-large {
    font-size: 80px!important;
}

#questions-stepper.v-sheet.v-stepper {
    border-radius: 0;
}

@media screen and (max-width: 960px) {
    #questions-stepper .v-stepper__items {
        height: calc(100vh - 48px - 68px - 72px - 48px - 3px);
        margin-top: 3px;
    }
}

@media screen and (max-width: 432px) {
    #questions-stepper .v-stepper__header {
        display: none;
    }

    #questions-stepper .v-stepper__items {
        height: calc(100vh - 48px - 68px - 48px - 3px);
    }
}
</style>